export default function westchesterReducer(state = [], action) {
  switch (action.type) {
    case "FETCH_WESTCHESTER":
      return [].concat.apply([], [...state, action.payload]);
    default:
      return state;
  }
}
